import flexibilityIcon from "../../img/categories-icons/flexibility-category-icon.svg";
import functionalyIcon from "../../img/categories-icons/functionaly-category-icon.svg";
import gymIcon from "../../img/categories-icons/gym-category-icon.svg";
import hiitIcon from "../../img/categories-icons/hiit-category-icon.svg";
import meditationIcon from "../../img/categories-icons/meditation-category-icon.svg";
import pilatisIcon from "../../img/categories-icons/pilatis-category-icon.svg";
import powerIcon from "../../img/categories-icons/power-category-icon.svg";
import shapeIcon from "../../img/categories-icons/shape-category-icon.svg";
import yogaIcon from "../../img/categories-icons/yoga-category-icon.svg";
import zombaIcon from "../../img/categories-icons/zomba-category-icon.svg";

// Static activity categories for the V2 flows — the home tiles and the search
// chips both read this list. It replaces GetClubCategoryList for V2 partners,
// which is why there are no backend IDs here.
//
// `label` is BOTH the displayed text and the SubCategoryName sent to
// GetMobileClubsIdsBySubCategory, so it has to match the backend's spelling
// exactly — a mismatch returns zero clubs rather than an error. Hebrew is inline
// rather than behind i18n keys by design decision.
//
// Order is the design's, right to left.
export const V2_CATEGORIES = [
  { key: "pilates", label: "פילאטיס מכשירים", icon: pilatisIcon },
  { key: "yoga", label: "יוגה", icon: yogaIcon },
  { key: "gym", label: "חדר כושר", icon: gymIcon },
  { key: "functional", label: "אימון פונקציונלי", icon: functionalyIcon },
  { key: "shape", label: "עיצוב וחיטוב", icon: shapeIcon },
  { key: "meditation", label: "מדיטציה", icon: meditationIcon },
  { key: "flexibility", label: "גמישות", icon: flexibilityIcon },
  { key: "zumba", label: "זומבה", icon: zombaIcon },
  { key: "hiit", label: "HIIT", icon: hiitIcon },
  { key: "power", label: "אימוני כוח", icon: powerIcon },
];
